import React from "react";

const WebPages_Email = () => {
  return (
    <div className="tutorial-page">
      <h1>WebPages Email</h1>
      <p>This is the WebPages Email page content.</p>
    </div>
  );
};

export default WebPages_Email;
